(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kaya-ebike"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('kaya-ebike'))customElements.define('kaya-ebike',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  this.config=JSON.parse(this.querySelector('[data-config]').textContent);
  if(this.config.mode!=='bicycle'&&!this.config?.frames?.length)return;
  this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);
  this.delivery=JSON.parse(this.querySelector('[data-delivery]')?.textContent||'{}');
  this.money=new Intl.NumberFormat(this.dataset.locale||'nl-NL',{style:'currency',currency:this.dataset.currency||'EUR'});
  this.addEventListener('change',()=>this.update());
  this.addEventListener('click',e=>{const b=e.target.closest('[data-image]');if(!b)return;const img=this.querySelector('.ke-main-image');if(img){img.src=b.dataset.image;img.removeAttribute('srcset');img.alt=b.dataset.alt;}});
  this.querySelector('form').addEventListener('submit',e=>{if(!this.selected?.available||this.config.mode==='pending')e.preventDefault();});
  const id=this.querySelector('[data-variant-id]').value;
  const initial=this.variants.find(v=>String(v.id)===id);
  const combo=(this.config.combinations||[]).find(c=>c.sku===initial?.sku);
  if(combo){for(const [kind,value]of Object.entries({frame:combo.frameValue,battery:combo.batterySku,charger:combo.chargerSku})){const inputs=this.querySelectorAll('input[name^="ke_'+kind+'_"]');for(const input of inputs)if(input.value===value)input.checked=true;}}
  if(this.config.mode==='bicycle'&&initial){for(const field of this.querySelectorAll('[data-basic-option]'))for(const input of field.querySelectorAll('input'))input.checked=input.value===initial.options[Number(field.dataset.basicOption)];}
  this.update();
  this.initGallery();
 }
 initGallery(){
  this.photos=JSON.parse(this.querySelector('[data-gallery]')?.textContent||'[]');this.photoIndex=0;
  this.gallery=this.querySelector('.ke-lightbox');if(!this.gallery||!this.photos.length)return;
  this.addEventListener('click',e=>{
   if(e.target.closest('.ke-gallery-open')){const src=this.querySelector('.ke-main-image')?.src||'';this.photoIndex=Math.max(0,this.photos.findIndex(p=>new URL(p.src,location.href).pathname===new URL(src,location.href).pathname));this.showPhoto();this.gallery.showModal();document.documentElement.classList.add('ke-gallery-active');}
   if(e.target.closest('[data-gallery-close]'))this.gallery.close();
   if(e.target.closest('[data-gallery-next]'))this.movePhoto(1);
   if(e.target.closest('[data-gallery-prev]'))this.movePhoto(-1);
   if(e.target.closest('[data-gallery-zoom]')){const zoomed=this.gallery.classList.toggle('is-zoomed');this.querySelector('[data-gallery-zoom]').setAttribute('aria-pressed',String(zoomed));}
  });
  this.gallery.addEventListener('close',()=>{document.documentElement.classList.remove('ke-gallery-active');this.querySelector('.ke-gallery-open')?.focus();});
  this.gallery.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();this.movePhoto(1);}if(e.key==='ArrowLeft'){e.preventDefault();this.movePhoto(-1);}});
  let startX=0;this.gallery.addEventListener('touchstart',e=>{startX=e.changedTouches[0].clientX;},{passive:true});this.gallery.addEventListener('touchend',e=>{if(this.gallery.classList.contains('is-zoomed'))return;const d=e.changedTouches[0].clientX-startX;if(Math.abs(d)>60)this.movePhoto(d<0?1:-1);},{passive:true});
 }
 showPhoto(){const photo=this.photos[this.photoIndex],img=this.querySelector('.ke-lightbox-image');img.src=photo.src;img.alt=photo.alt;this.put('[data-gallery-counter]',(this.photoIndex+1)+' / '+this.photos.length);this.gallery.classList.remove('is-zoomed');this.querySelector('[data-gallery-zoom]').setAttribute('aria-pressed','false');for(const b of this.querySelectorAll('[data-gallery-prev],[data-gallery-next]'))b.hidden=this.photos.length<2;}
 movePhoto(delta){this.photoIndex=(this.photoIndex+delta+this.photos.length)%this.photos.length;this.showPhoto();}
 chosen(kind){return this.querySelector('input[name^="ke_'+kind+'_"]:checked')?.value||this.querySelector('input[type="hidden"][name^="ke_'+kind+'_"]')?.value;}
 put(selector,text){const e=this.querySelector(selector);if(e)e.textContent=text;}
 update(){
  if(this.config.mode==='bicycle'){this.updateBicycle();return;}
  const c=this.config,f=c.frames.find(f=>f.value===this.chosen('frame'))||c.frames[0];
  let battery,charger;
  if(c.mode==='configurable'){
   for(const kind of ['battery','charger']){
    const parts=kind==='battery'?c.batteries:c.chargers,allowed=kind==='battery'?f.batterySkus:f.chargerSkus;
    let value=this.chosen(kind);if(!allowed.includes(value))value=allowed[0];
    const minimum=Math.min(...parts.filter(p=>allowed.includes(p.sku)).map(p=>p.priceCents));
    for(const card of this.querySelectorAll('[data-part-kind="'+kind+'"]')){const ok=allowed.includes(card.dataset.partSku),input=card.querySelector('input'),p=parts.find(p=>p.sku===card.dataset.partSku);card.hidden=!ok;input.disabled=!ok;input.checked=p.sku===value;card.querySelector('[data-delta]').textContent=p.priceCents===minimum?this.dataset.included:'+ '+this.money.format((p.priceCents-minimum)/100);}
    if(kind==='battery')battery=parts.find(p=>p.sku===value);else charger=parts.find(p=>p.sku===value);
   }
  }
  const combo=c.combinations.find(x=>x.frameValue===f.value&&(c.mode!=='configurable'||x.batterySku===battery.sku&&x.chargerSku===charger.sku));
  this.selected=this.variants.find(v=>v.sku===combo?.sku);
  this.querySelector('[data-variant-id]').value=this.selected?.id||'';
  const price=n=>this.money.format(n/100);
  this.put('[data-base-price]',price(f.basePriceCents));this.put('[data-spec-frame]',f.value);
  if(battery){this.put('[data-battery-name]',battery.name);this.put('[data-battery-price]',price(battery.priceCents));this.put('[data-charger-name]',charger.name);this.put('[data-charger-price]',price(charger.priceCents));}
  this.put('[data-fixed-battery]',f.batteryName);this.put('[data-fixed-charger]',f.chargerName);
  for(const kind of ['battery','charger']){const image=this.querySelector('[data-fixed-'+kind+'-image]');if(image){image.hidden=!f[kind+'Image'];if(f[kind+'Image'])image.src=f[kind+'Image'];image.alt=f[kind+'Name'];}}
  this.put('[data-total]',price(this.selected?.price??combo?.priceCents??f.basePriceCents));
  const button=this.querySelector('[data-add-button]');button.disabled=!this.selected?.available||c.mode==='pending';button.textContent=button.disabled?this.dataset.unavailable:this.dataset.add;
  this.put('[data-delivery-status]',this.delivery[this.selected?.id]||'—');
  if(this.selected){const url=new URL(location.href);url.searchParams.set('variant',this.selected.id);history.replaceState({},'',url);}
 }
 updateBicycle(){
  const fields=[...this.querySelectorAll('[data-basic-option]')];
  const values=fields.map(f=>f.querySelector('input:checked')?.value);
  this.selected=fields.length?this.variants.find(v=>v.options.every((o,i)=>o===values[i])):this.variants[0];
  const v=this.selected,price=n=>this.money.format(n/100);
  this.querySelector('[data-variant-id]').value=v?.id||'';
  this.put('[data-base-price]',v?price(v.price):'—');this.put('[data-total]',v?price(v.price):'—');
  const compare=this.querySelector('[data-compare-price]');if(compare){compare.hidden=!(v?.compare_at_price>v?.price);compare.textContent=v?.compare_at_price?price(v.compare_at_price):'';}
  this.put('[data-spec-frame]',v?.option1||'—');
  const button=this.querySelector('[data-add-button]');button.disabled=!v?.available;button.textContent=button.disabled?this.dataset.unavailable:this.dataset.add;
  this.put('[data-delivery-status]',this.delivery[v?.id]||'—');
  if(v){const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);if(v.featured_image?.src){const img=this.querySelector('.ke-main-image');if(img){img.src=v.featured_image.src;img.alt=v.featured_image.alt||this.querySelector('h1').textContent;img.removeAttribute('srcset');}}}
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaya-footer-exact"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kaya-footer-exact')) {
  customElements.define('kaya-footer-exact', class extends HTMLElement {
    connectedCallback() {
      this.media = window.matchMedia('(max-width: 749px)');
      this.sync = () => {
        this.querySelectorAll('.kf-fold').forEach(details => {
          details.open = !this.media.matches;
          details.querySelector('summary').tabIndex = this.media.matches ? 0 : -1;
        });
      };
      this.media.addEventListener('change', this.sync);
      this.sync();
      if (this.querySelector('.kf-message')) this.querySelectorAll('.kf-message').forEach(message => message.scrollIntoView({block: 'center'}));
    }
    disconnectedCallback() { this.media?.removeEventListener('change', this.sync); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
